export default __webpack_public_path__ + "static/illustration-content-title.url-4d96ef7bd994bc694f7672f445bfccd4.svg";